import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import orderBy from 'lodash/orderBy';

import { LegalEntityData } from 'chaika-frontend-types/frontend-cms';
import { LegalEntityType } from 'chaika-enums';

import { legalEntityQueryOptions } from '@organization/queries/legalEntityQueries';
import { store } from '@store';

const EMPTY: LegalEntityData[] = [];

export function useAccountantLegalEntities(): LegalEntityData[] {
    const { authUser } = store;
    // Root users (Helpdesk / Developer) are rare and need every LE; everyone else is scoped to the LEs they account for.
    const { data } = useQuery(
        authUser.hasRootAccess ? legalEntityQueryOptions.list() : legalEntityQueryOptions.forAccountant([authUser.id]),
    );
    return useMemo(() => (data ? orderBy(data, ({ type }) => type === LegalEntityType.Clinic, 'desc') : EMPTY), [data]);
}
